import React from 'react';
import { renderManagementCredentials } from './managementCredentials';

export default user => {
  const columns = [
    {
      title: 'Username',
      field: 'username',
      editable: 'onAdd'
    },
    {
      title: 'Nome',
      field: 'name',
      editable: 'onAdd'
    },
    {
      title: 'Email',
      field: 'email',
      editable: 'onAdd'
    },
    {
      title: 'Password',
      field: 'password',
      editable: 'onAdd',
    },
    {
      title: 'Permissões',
      field: 'administrator',
      type: 'boolean',
      lookup: {
        'true': 'Administrador',
        'false': 'Utilizador'
      },
      initialEditValue: 'false',
      render: renderManagementCredentials,
    },
    {
      title: 'Acesso',
      field: 'inventory_only',
      lookup: {
        true: 'Inventário',
        false: 'Normal'
      },
      initialEditValue: true,
      render: rowData => (
        rowData.inventory_only
          ? <span style={{ color: 'orange' }}>Inventário</span>
          : <span style={{ color: 'green' }}>Normal</span>
      ),
    },
    {
      title: 'Estado',
      field: 'active',
      type: 'boolean',
      lookup: {
        'true': 'Activo',
        'false': 'Inactivo'
      },

      // A user is created active. The column is not editable while adding, so
      // this value is what the form sends, and it used to send 'false' - which
      // would have kept new users disabled no matter what the API defaults to.
      initialEditValue: 'true',
      render: rowData => {
        if (rowData.active === 'true' || rowData.active === true) {
          return <span style={{ color: 'green' }}>Activo</span>;
        } else if (rowData.active === 'false' || rowData.active === false) {
          return <span style={{ color: 'red' }}>Inactivo</span>;
        }
      },
      editable: user.superuser || user.administrator ? 'onUpdate' : 'never'
    },
    {
      title: 'Ultimo login',
      field: 'last_login',
      type: 'date',
      editable: 'never'
    }
  ];

  const columnsAdmin = [
    {
      title: 'Identificador',
      field: 'id',
      editable: 'never',
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
